import {
  RestaurantSearchbar,
  RestaurantSwitcherList,
  applyRestaurantSwitch,
} from '@/components/RestaurantSwitcherSheet';
import { useT } from '@/i18n';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useUiStore } from '@/stores/ui.store';
import { Navbar, Page, f7 } from 'framework7-react';
import { useState } from 'react';

/**
 * The phone switcher: a full pushed page instead of the bottom sheet. The sheet
 * couldn't scroll its long, franchise-grouped list reliably, so on phones we
 * push a normal router page (desktop keeps the anchored popover). Picking a row
 * IS the action — no Save button — same as the sheet.
 */
export default function RestaurantSwitcherPage() {
  const t = useT();
  const selectedRestaurantId = useRestaurantStore((s) => s.selectedRestaurantId);
  const [query, setQuery] = useState('');

  const handlePick = (franchiseId: string, restaurantId: string, name: string) => {
    if (restaurantId === selectedRestaurantId) {
      f7.views.current?.router.back();
      return;
    }
    useUiStore.getState().setSettingsTabRestaurantId(restaurantId);
    applyRestaurantSwitch(franchiseId, restaurantId, name);
  };

  return (
    <Page name="switch-restaurant" className="page-with-subnavbar">
      <Navbar title={t.settings.switchRestaurant} backLink={t.settings.title}>
        <RestaurantSearchbar query={query} onQuery={setQuery} />
      </Navbar>
      <RestaurantSwitcherList
        selectedRestaurantId={selectedRestaurantId}
        query={query}
        onPick={handlePick}
      />
    </Page>
  );
}
